import styled from '@emotion/styled';
import { Theme } from '@/styles/Theme';

export const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1rem;
  background-color: ${Theme.colors.WHITE};
  border: 0.0625rem solid ${Theme.colors.G_3};
  border-radius: 0.5rem;
`;

export const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
`;

export const InfoLabel = styled.span`
  font-size: 1rem;
  font-weight: 600;
  color: ${Theme.colors.DG_1};
  min-width: 8rem;
`;

export const InfoValue = styled.span`
  font-size: 1rem;
  color: ${Theme.colors.BLACK};
  text-align: right;
`;

export const WorkersSection = styled.div`
  padding: 1rem;
  background-color: ${Theme.colors.WHITE};
  border: 0.0625rem solid ${Theme.colors.G_3};
  border-radius: 0.5rem;
`;

export const WorkersTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 0.75rem;
`;

export const WorkersThead = styled.thead`
  background-color: ${Theme.colors.G_6};
  border-bottom: 0.125rem solid ${Theme.colors.G_3};
`;

export const WorkersTr = styled.tr`
  border-bottom: 0.0625rem solid ${Theme.colors.G_3};
`;

export const WorkersTh = styled.th`
  padding: 0.75rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: ${Theme.colors.BLACK};
  text-align: center;
`;

export const WorkersTbody = styled.tbody`
  background-color: ${Theme.colors.WHITE};
`;

export const WorkersTd = styled.td`
  padding: 0.75rem;
  font-size: 0.875rem;
  color: ${Theme.colors.BLACK};
  text-align: center;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  align-items: center;
`;

export const ConfirmationSection = styled.div`
  padding: 1rem;
  background-color: ${Theme.colors.WHITE};
  border: 0.0625rem solid ${Theme.colors.G_3};
  border-radius: 0.5rem;
`;

export const ConfirmationLabel = styled.label`
  display: block;
  font-size: 1rem;
  font-weight: 600;
  color: ${Theme.colors.DG_1};
  margin-bottom: 0.5rem;
`;

export const ConfirmationTextarea = styled.textarea`
  width: 100%;
  min-height: 6rem;
  padding: 0.75rem;
  border: 0.0625rem solid ${Theme.colors.G_3};
  border-radius: 0.5rem;
  font-size: 1rem;
  font-family: inherit;
  resize: vertical;
  &:focus {
    outline: none;
    border-color: ${Theme.colors.B_3};
  }
`;

export const FileInputWrapper = styled.div`
  margin-top: 1rem;
`;

export const FileInputLabel = styled.label`
  display: inline-block;
  padding: 0.5rem 1rem;
  background-color: ${Theme.colors.G_6};
  border: 0.0625rem solid ${Theme.colors.G_3};
  border-radius: 0.5rem;
  cursor: pointer;
  font-size: 0.875rem;
  &:hover {
    background-color: ${Theme.colors.G_5};
  }
`;

export const FileInput = styled.input`
  display: none;
`;

export const ImagePreview = styled.div`
  margin-top: 0.75rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const ImagePreviewImg = styled.img`
  max-width: 10rem;
  max-height: 10rem;
  border: 0.0625rem solid ${Theme.colors.G_3};
  border-radius: 0.5rem;
`;

export const ImageRemoveButton = styled.button`
  padding: 0.25rem 0.5rem;
  background-color: ${Theme.colors.WARNING_RED};
  color: ${Theme.colors.WHITE};
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
  font-size: 0.875rem;
  &:hover {
    opacity: 0.8;
  }
`;


